import type { TypeSelectOption } from '@thefarmersfront/kitchen';

import { transformToSelectOptions } from '~/utils';

import type { TypeStockCodeDescription } from '~/types/stock.types';

const transformToStockSelectOptions = (arr: TypeStockCodeDescription[]): TypeSelectOption<string>[] => {
  return transformToSelectOptions(arr, 'code', 'name');
};

export default transformToStockSelectOptions;
